/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.microcredentialing.classrooms'},
});

const MyStudentsItem = () => (
  <RouteLinkItem
    route="midas/microcredentialing/classrooms"
    title={messages.title}
  />
);

export default MyStudentsItem;
